import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Money } from "@/components/shared/Common";
import { Users, Stethoscope, CalendarDays, CircleDollarSign } from "lucide-react";

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then(r => setS(r.data)); }, []);
  return (
    <div className="space-y-6">
      <div><div className="cm-eyebrow mb-2">Admin overview</div><h1 className="cm-h2">Platform performance</h1></div>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat icon={<Users size={18}/>} label="Patients" value={s?.patients} testid="admin-stat-patients"/>
        <Stat icon={<Stethoscope size={18}/>} label="Doctors" value={s?.doctors} testid="admin-stat-doctors"/>
        <Stat icon={<CalendarDays size={18}/>} label="Appointments" value={s?.appointments} testid="admin-stat-appts"/>
        <Stat icon={<CircleDollarSign size={18}/>} label="Platform revenue" value={<Money amount={s?.platform_revenue}/>} testid="admin-stat-revenue"/>
      </div>
      <div className="grid md:grid-cols-3 gap-4">
        <div className="cm-card"><div className="cm-eyebrow mb-1">Verified doctors</div><div className="text-3xl font-bold text-[#1a2b4a]">{s?.verified_doctors ?? "—"}</div></div>
        <div className="cm-card"><div className="cm-eyebrow mb-1">Pending verifications</div><div className="text-3xl font-bold text-[#1a2b4a]">{s?.pending_verifications ?? "—"}</div></div>
        <div className="cm-card"><div className="cm-eyebrow mb-1">Gross bookings</div><div className="text-3xl font-bold text-[#1a2b4a]"><Money amount={s?.gross_revenue}/></div></div>
      </div>
    </div>
  );
}

const Stat = ({ icon, label, value, testid }) => (
  <div className="cm-card" data-testid={testid}>
    <div className="w-9 h-9 rounded-lg bg-[#ebf3fc] text-[#4a90d9] flex items-center justify-center mb-3">{icon}</div>
    <div className="text-xs uppercase tracking-wider text-[#4a90d9] font-semibold">{label}</div>
    <div className="text-2xl font-bold text-[#1a2b4a] mt-1">{value ?? "—"}</div>
  </div>
);
